

























import { Component } from "vue-property-decorator";
import MedPartBase from "./MedPartBase";

@Component
export default class ComprehensiveDiv extends MedPartBase {
  // 包括型訪問看護療養費の算定有無を取得
  private get isComprehensiveChecked(): boolean {
    return this.receiptVisitRecord?.comprehensive_flg === 1 ||
      this.receiptVisitRecord?.comprehensive_sub_flg === 1
      ? true
      : false;
  }
}
